import { PlannerBase }   from "../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
import {
  PLANNER_CLICK_SEARCH_COLLAPSE,
} from 'apps/events';

class ShowAllPhases extends PlannerBase {
  show: boolean;
  // status: Array<any> = [];
  // orderType: Array<any> = [];
  // phaseId: Array<any> = [];
  init(){
    super.init();
    this.show = false;
    this.watch();
    // this.setProps(this.opts)
  }
  onClickOpenButton(e){
    let el = document.getElementById('planner-index');
    if(el == null){ return false; }
    let className = 'show-all-phases';
    if (el.classList)
      el.classList.add(className);
    else
      el.className += ' ' + className;
    this.show = true;
    this.update();
  }
  onClickCloseButton(){
    let el = document.getElementById('planner-index');
    if(el == null){ return false; }
    let className = 'show-all-phases';
    if (el.classList)
      el.classList.remove(className);
    else
      el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    this.show = false;
    this.update();
  }
}
riot.mixin('orders.planner.show-all-phases', ShowAllPhases as riot.TagMixin)
